/**
 * Morphing animation logic for API Loader
 * # ⛓️ CURSOR_ANCHOR:search:api-loader-morphing
 */

(function() {
  'use strict';

  function getFragmentBuilder() { return window.SEARCH_RESULTS_API_LOADER_STATE.getFragmentBuilder(); }
  function getDeps() { return window.SEARCH_RESULTS_API_LOADER_STATE.getDeps(); }

  /**
   * Функция для обработки ответа без morphing
   */
  function handleResponseWithoutMorphing(data, container, nothingFoundText, searchTerm, currentLang, searchType, thisSearchId, state) {
    var fragmentBuilder = getFragmentBuilder();
    var deps = getDeps();
    var createResultsFragment = fragmentBuilder.createResultsFragment || function() { return document.createDocumentFragment(); };
    var initAccordion = deps.initAccordion || function() {};
    var initDictNameHandlers = deps.initDictNameHandlers || function() {};
    
    var newEntries = data.success && data.results.count > 0 ? data.results.entries : null;
    var message = data.success && data.results.message ? data.results.message : null;
    var suggestions = data.success && data.results.suggestions ? data.results.suggestions : null;

    // Проверяем, нужно ли пропустить анимацию (навигация из истории или по хэшу)
    var skipAnimation = !!(window.PENDING_TERM_GUID || window.PENDING_TERM_INDEX || window.location.hash);

    // Плавный переход контейнера: при navigate-to-term (skipAnimation) пропускаем,
    // иначе translateY(20px) во время fade-in сдвигал target у getBoundingClientRect
    // → performScrollToElement считал позицию с запасом и статья уезжала за sticky-панели.
    if (!skipAnimation) {
      container.classList.add('results-fade-in');
      container.classList.remove('results-visible');
    }

    // Небольшая задержка перед вставкой контента, чтобы анимация была заметна
    setTimeout(function() {
      container.innerHTML = '';
      var fragment = createResultsFragment(newEntries, nothingFoundText, message, searchType, searchTerm, {
        skipAnimation: skipAnimation,
        suggestions: suggestions
      });
      container.appendChild(fragment);
      
      initAccordion();
      initDictNameHandlers();
      if (window.SLOVARY_REF_COLLAPSED && window.SLOVARY_REF_COLLAPSED.init) {
        window.SLOVARY_REF_COLLAPSED.init(container);
      }
      
      // Показываем результаты с эффектом "всплытия"
      requestAnimationFrame(function() {
        container.classList.add('results-visible');
        container.classList.remove('results-fade-in');
      });
    }, 50);
    
    // Обрабатываем навигацию к конкретному термину после загрузки результатов (из истории / URL)
    // GUID имеет приоритет над позиционным индексом; expandTermFromHash() читает хэш из URL
    if (window.PENDING_TERM_GUID || window.PENDING_TERM_INDEX) {
      var scrollAttempts = 0;
      var maxScrollAttempts = 5;
      var tryScrollFromHistory = function() {
        scrollAttempts++;
        var results = document.querySelectorAll('.opredelenie');
        if (results.length > 0) {
          if (window.SEARCH_UI && window.SEARCH_UI.expandTermFromHash) {
            window.SEARCH_UI.expandTermFromHash();
          } else if (window.expandTermFromHash) {
            window.expandTermFromHash();
          }
          window.PENDING_TERM_GUID = null;
          window.PENDING_TERM_INDEX = null;
        } else if (scrollAttempts < maxScrollAttempts) {
          setTimeout(tryScrollFromHistory, 300);
        } else {
          window.PENDING_TERM_GUID = null;
          window.PENDING_TERM_INDEX = null;
        }
      };
      // Ждём 2 rAF + короткий таймер: задержка перед скроллом минимальна,
      // но layout sticky-панелей (форма + breadcrumb) успевает устояться.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          setTimeout(tryScrollFromHistory, 120);
        });
      });
    }

    // Сохраняем в историю с небольшой задержкой, чтобы DOM успел обновиться
    if (window.SEARCH_HISTORY && window.SEARCH_HISTORY.saveSearchToHistory) {
      setTimeout(function() {
        window.SEARCH_HISTORY.saveSearchToHistory(searchTerm, currentLang, searchType);
      }, 50);
    }
  }

  /**
   * Функция для обработки morphing анимации
   */
  function handleMorphingAnimation(newEntries, nothingFoundText, message, container, firstResultElement, thisSearchId, state, searchTerm, currentLang, searchType) {
    var fragmentBuilder = getFragmentBuilder();
    var deps = getDeps();
    var createResultsFragment = fragmentBuilder.createResultsFragment || function() { return document.createDocumentFragment(); };
    var initAccordion = deps.initAccordion || function() {};
    var initDictNameHandlers = deps.initDictNameHandlers || function() {};
    var isRequestCurrent = state.isRequestCurrent || function() { return false; };
    
    var morphWrapper = document.createElement('div');
    morphWrapper.className = 'morph-wrapper';
    
    if (!isRequestCurrent(thisSearchId)) {
      console.log('[SEARCH] Игнорируем устаревший morphing');
      return;
    }
    
    if (firstResultElement && firstResultElement.parentNode === container) {
      try {
        container.insertBefore(morphWrapper, firstResultElement);
      } catch (e) {
        console.error('[SEARCH] Ошибка при вставке morphWrapper:', e);
        container.appendChild(morphWrapper);
      }
    } else {
      if (container.firstChild) {
        try {
          container.insertBefore(morphWrapper, container.firstChild);
        } catch (e) {
          container.appendChild(morphWrapper);
        }
      } else {
        container.appendChild(morphWrapper);
      }
    }
    
    var oldLayer = document.createElement('div');
    oldLayer.className = 'morph-layer';
    
    // Проверяем, нужно ли пропустить анимацию (навигация из истории или по хэшу)
    var skipAnimation = !!(window.PENDING_TERM_GUID || window.PENDING_TERM_INDEX || window.location.hash);

    if (!isRequestCurrent(thisSearchId)) {
      console.log('[SEARCH] Игнорируем устаревшее перемещение элементов');
      if (morphWrapper.parentNode === container) {
        container.removeChild(morphWrapper);
      }
      return;
    }
    
    if (firstResultElement && firstResultElement.parentNode === container) {
      var current = firstResultElement;
      var elementsToMove = [];
      while (current) {
        if (current.parentNode === container) {
          elementsToMove.push(current);
        }
        current = current.nextSibling;
      }
      elementsToMove.forEach(function(element) {
        if (element.parentNode === container) {
          try {
            oldLayer.appendChild(element);
          } catch (e) {
            console.error('[SEARCH] Ошибка при перемещении элемента:', e);
          }
        }
      });
    } else {
      var allResultElements = Array.from(container.querySelectorAll('[data-search-result="true"]'));
      allResultElements.forEach(function(result) {
        if (result.parentNode === container) {
          try {
            oldLayer.appendChild(result);
          } catch (e) {
            console.error('[SEARCH] Ошибка при перемещении результата:', e);
          }
        }
      });
    }
    
    morphWrapper.appendChild(oldLayer);
    
    var newLayer = document.createElement('div');
    newLayer.className = 'morph-layer morphing-initial';
    var newFragment = createResultsFragment(newEntries, nothingFoundText, message, searchType, searchTerm, {
      skipAnimation: skipAnimation
    });
    newLayer.appendChild(newFragment);
    
    var newDescrElements = newLayer.querySelectorAll('.descr');
    newDescrElements.forEach(function(descr) {
      descr.style.display = 'none';
    });
    
    morphWrapper.appendChild(newLayer);
    
    requestAnimationFrame(function() {
      if (!isRequestCurrent(thisSearchId)) {
        console.log('[SEARCH] Игнорируем устаревшую анимацию');
        if (morphWrapper.parentNode === container) {
          container.removeChild(morphWrapper);
        }
        return;
      }
      
      var hasNewResults = newEntries && newEntries.length > 0;
      
      if (hasNewResults) {
        oldLayer.classList.add('morphing-out');
      } else {
        oldLayer.classList.add('morphing-out-fast');
      }
      
      newLayer.classList.remove('morphing-initial');
      newLayer.classList.add('morphing-in');
      
      setTimeout(function() {
        if (!isRequestCurrent(thisSearchId)) {
          if (morphWrapper.parentNode === container) {
            container.removeChild(morphWrapper);
          }
          return;
        }
        
        if (!newLayer || !newLayer.parentNode) {
          console.log('[SEARCH] newLayer уже удален, пропускаем перемещение');
          return;
        }
        
        if (morphWrapper.parentNode !== container) {
          console.log('[SEARCH] morphWrapper уже удален, добавляем результаты напрямую');
          var fragment = document.createDocumentFragment();
          var maxIterations = 1000;
          var iteration = 0;
          while (newLayer && newLayer.firstChild && iteration < maxIterations) {
            var child = newLayer.firstChild;
            fragment.appendChild(child);
            iteration++;
          }
          if (iteration >= maxIterations) {
            console.error('[SEARCH] Превышено максимальное количество итераций при создании fragment');
          }
          container.appendChild(fragment);
          initAccordion();
          initDictNameHandlers();
          return;
        }
        
        var childrenToMove = [];
        var maxIterations = 1000;
        var iteration = 0;
        if (newLayer && newLayer.parentNode) {
          while (newLayer.firstChild && iteration < maxIterations) {
            var child = newLayer.firstChild;
            childrenToMove.push(child);
            newLayer.removeChild(child);
            iteration++;
          }
        }
        
        if (iteration >= maxIterations) {
          console.error('[SEARCH] Превышено максимальное количество итераций при перемещении элементов');
        }
        
        childrenToMove.forEach(function(child) {
          if (morphWrapper.parentNode === container) {
            try {
              container.insertBefore(child, morphWrapper);
            } catch (e) {
              console.error('[SEARCH] Ошибка при вставке элемента:', e);
              container.appendChild(child);
            }
          } else {
            container.appendChild(child);
          }
        });
        
        if (morphWrapper.parentNode === container) {
          container.removeChild(morphWrapper);
        }
        
        initAccordion();
        initDictNameHandlers();
        
        // Обрабатываем навигацию к конкретному термину после завершения анимации (из истории / URL)
        if (window.PENDING_TERM_GUID || window.PENDING_TERM_INDEX) {
          var scrollAttempts = 0;
          var maxScrollAttempts = 5;
          var tryScrollFromHistory = function() {
            scrollAttempts++;
            var results = document.querySelectorAll('.opredelenie');
            if (results.length > 0) {
              if (window.SEARCH_UI && window.SEARCH_UI.expandTermFromHash) {
                window.SEARCH_UI.expandTermFromHash();
              } else if (window.expandTermFromHash) {
                window.expandTermFromHash();
              }
              window.PENDING_TERM_GUID = null;
              window.PENDING_TERM_INDEX = null;
            } else if (scrollAttempts < maxScrollAttempts) {
              setTimeout(tryScrollFromHistory, 300);
            } else {
              window.PENDING_TERM_GUID = null;
              window.PENDING_TERM_INDEX = null;
            }
          };
          setTimeout(tryScrollFromHistory, 600);
        }
        
        if (window.SEARCH_HISTORY && window.SEARCH_HISTORY.saveSearchToHistory) {
          window.SEARCH_HISTORY.saveSearchToHistory(searchTerm, currentLang, searchType);
        }
      }, hasNewResults ? 1000 : 200);
    });
  }

  window.SEARCH_RESULTS_API_LOADER_MORPHING = {
    handleResponseWithoutMorphing: handleResponseWithoutMorphing,
    handleMorphingAnimation: handleMorphingAnimation
  };
})();

